<div class="dialog" role="dialog" aria-modal="true" [attr.aria-label]="isEditMode ? 'Uredi tekmovanje' : 'Dodaj tekmovanje'">
  <div class="dialog-header">
    <h3>{{ isEditMode ? 'Uredi tekmovanje' : 'Dodaj tekmovanje' }}</h3>
    <span class="dialog-kicker">Tekmovanja</span>
  </div>
  <form class="dialog-form" (ngSubmit)="onSave()">
    <label class="field">
      <span>Ime tekmovanja</span>
      <input type="text" [(ngModel)]="competition.competition_name" name="competition_name" required autocomplete="off">
    </label>
    <label class="field">
      <span>Datum</span>
      <input type="date" [(ngModel)]="competition.competition_date" name="competition_date" required>
    </label>
    <label class="teiler-option">
      <input type="checkbox" [(ngModel)]="competition.is_teiler" name="is_teiler">
      <span>
        <strong>Teiler tekmovanje</strong>
        <small>Rezultati se razvrstijo po najnižji vrednosti Teiler.</small>
      </span>
    </label>
    <div class="dialog-actions">
      <button class="button button-primary" type="submit">{{ isEditMode ? 'Shrani spremembe' : 'Shrani' }}</button>
      <button class="button button-secondary" type="button" (click)="onCancel()">Prekliči</button>
    </div>
  </form>
</div>